<template>
    <div>
        <a-button type="primary" class="m-b-20" @click="showGoods=true">添加礼品</a-button>
         <a-table :loading='listLoading' :columns='columns' :data-source='list' rowKey='id' bordered :pagination="false">
             <template v-slot:gift="{record}">
                <div>
                   <img :src="record.image?oss+record.image:'@/assets/images/normal.png'" style="width:80px;height:80px;border-radius:5px" class="m-r-15"/>
                   <span>{{record.name}}</span>
                </div>
             </template>
              <template v-slot:num="{record}">
                  <a-input-number :max="999" :min="1" :precision="0" v-model:value="record.number" placeholder="请输入数量" style="width:80%"></a-input-number>
                  <p class="fz-12 s_ce814 text-al p-l-20 m-t-5" v-show="!record.number">请输入数量</p>
              </template>
              <template v-slot:action="{record}">
                  <a-button type="primary" danger @click="delGoods(record)">删除</a-button>
              </template>
         </a-table>
          <a-button type="primary" class="m-b-20 m-t-30" style="margin-left:50%;" @click="submit">保存</a-button>

          <a-modal :keyboard="false" title="选择商品" v-model:visible="showGoods" centered :width='1000' :footer="null" destroyOnClose>
            <goodsList @change="onChange" :goodsId="allChecked"></goodsList>
          </a-modal>
    </div>
</template>
<script>
import config from "@/config";
import goodsList from './goods_list'
import { onMounted, reactive, toRefs } from 'vue'
import { message } from 'ant-design-vue';
 const oss = config.oss[process.env.VUE_APP_type];
const columns = [
     {
       title: "礼品名称",
       dataIndex: "name",
       slots: { customRender: "gift" },
     },
     {
       title: "规格",
       dataIndex: "sku_name",
        width:140,
        align:'center'
     },
      {
       title: "数量",
       dataIndex: "number",
       slots: { customRender: "num" },
       width:200,
        align:'center'
     },
       {
       title: "操作",
       dataIndex: "4",
       slots: { customRender: "action" },
        width:120,
        align:'center'
     },
]
export default{
    components:{
        goodsList
    },
    props:{
        goodsList:{
            type:Object,
            default:()=>{}
        }
    },
    setup(props,{emit}){

        const state = reactive({
              listLoading:false,
              list:[],
              showGoods:false,
              goodsData:{},
              allChecked:{},
        })
        const methods= {
            onChange(data){
                // console.log(data,'3')
                let arr = JSON.parse(JSON.stringify(data));
                state.allChecked = arr || {};
                state.list = Object.values(arr) || []
                state.showGoods = false;
            },
            delGoods(record){
                delete state.allChecked[record.id +'_'+record.sku_sn]
                state.list = Object.values(state.allChecked) || [];
            },
            submit(){
                const hide = message.loading('正在加载中...', 0);
                 let goods_list = []
                 let total_number = 0;
                 for(let i=0;i<state.list.length;i++){
                      if(!state.list[i].number){
                          message.error('请输入礼品数量！')
                          setTimeout(hide);
                          return
                       }else{
                          total_number+=state.list[i].number
                          goods_list.push({
                              goods_id:state.list[i].id,
                              sku_sn:state.list[i].sku_sn,
                              goods_type:state.list[i].goods_type,
                              number:state.list[i].number,
                              image_url:state.list[i].image,
                              sku_sn_name:state.list[i].sku_name,
                              name:state.list[i].name
                          })
                       }
                 }
                 setTimeout(hide);
                 emit('confirm',goods_list,total_number)
            },
            getGoods(){
                const hide = message.loading('正在加载中...', 0);
                state.list = [];
                props.goodsList.goods.forEach(v => {
                    state.list.push({
                        id:v.goods_id,
                        sku_sn:v.sku_sn,
                        spec_type:v.goods_type,
                        number:v.number,
                        image:v.image_url,
                        sku_name:v.sku_sn_name,
                        name:v.name
                    })
                });
                 state.allChecked = {};
                 state.list.forEach((item)=>{
                    state.allChecked[item.id +'_'+item.sku_sn] = item;
                 })
                  setTimeout(hide);
            }
        }
        onMounted(()=>{
            if(props.goodsList['goods']){
                if(props.goodsList.goods.length==0) return
                 methods.getGoods()
            }
        })
       return{
           oss,
           columns,
           ...toRefs(state),
           ...methods
       }
    }
}
</script>

